module.exports = __webpack_public_path__ + "img/公司前台.604a7c12.jpg";